import { Inject, Injectable, Optional } from '@angular/core';
import { ScriptLoader, WindowRef } from '@spartacus/core';
import { Request } from 'express';

import { ConfigurationService } from './configuration.service';
import { SERVER_REQUEST } from '../constants';
import { getDomain } from '../utils';

@Injectable({
  providedIn: 'root'
})
export class TwicpicsService {
  private _active = false;
  private _twicpicsDomain: string;

  get isActive(): boolean {
    return this._active;
  }

  get twicpicsDomain(): string {
    return this._twicpicsDomain;
  }

  constructor(
    private readonly scriptLoader: ScriptLoader,
    private readonly configService: ConfigurationService,
    @Optional() @Inject(SERVER_REQUEST) private readonly request: Request,
    private readonly winRef: WindowRef
  ) {
    this.init();
  }

  init(): void {
    this.configService.getConfig().subscribe(({ twicpics }) => {
      if (twicpics?.isEnabled) {
        this._active = true;
        this._twicpicsDomain = twicpics.forcedDomain || this.generateTwicpicsDomain();
        this.scriptLoader.embedScript({ src: `https://${this._twicpicsDomain}/?v1` });
      }
    });
  }

  generateTwicpicsDomain(): string {
    const host = this.winRef.isBrowser() ? this.winRef.nativeWindow.location.hostname : this.request.hostname;
    const siteDomain = getDomain(host);
    return `twicpics.${siteDomain}`;
  }

  normalizeMediaUrl(url: string): string {
    if (new RegExp(/^(http|data:image|\/\/)/i).test(url)) {
      return url;
    }
    return 'image:' + url;
  }
}
